export const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
export const THROTTLE_DELAY_MS = 5000;
export const HEARTBEAT_INTERVAL_MS = 60 * 1000;
export const STORAGE_KEY = 'lastActivityTimestamp';
export const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keydown',
  'scroll',
  'touchstart',
  'click',
];
